<template>
  <div class="pa-2 text-center">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on" :color="hasFile ? 'green' : ''">
          {{ hasFile ? 'done' : 'horizontal_rule' }}
        </v-icon>
      </template>
      <span>{{ hasFile ? $t('adminVideo.fileStatusUpload') : $t('adminVideo.fileStatusEmpty') }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'AdminLineCheckStatus',

  props: {
    hasFile: Boolean
  }
}
</script>
